export const facturacion = {
    text1: "Metodo di pagamento",
    text2: "Carta di credito",
    text3: "Nessun metodo di pagamento registrato",
    text4: "Modifica il tuo metodo di pagamento",
    text5: "Aggiungi metodo di pagamento",
    text6: "Aggiungi un metodo di pagamento",
    text7: "Aggiorna un metodo di pagamento",
    text8: "Registra o aggiorna il metodo di pagamento su cui verranno effettuati gli addebiti mensili.",
    text9: "Numero della carta:",
    text10: "Scad.",
    text11: "CVC",
    text12: "Salva carta",
    text13: "Numero non valido",
    text14: "Non valido",
    text15: "CVC non valido.",
    text16: "Qualcosa è andato storto",
    text17: "Consumo",
    text18: "Fatture emesse",
    text19: "Da - A",
    text20: "ID",
    text21: "Importo",
    text22: "Soggetto emittente della fattura",
    text23: "BIG NERDS COMPANY L.L.C.",
    text24: "Data di emissione",
    text25: "Stato",
    text26: "Scarica fattura",
    text27: "Generazione fattura ...",
    text28: "Quasi finito, attendere...",
    text29: "Caricamento ...",
    text30: "Spiacenti, non è stato possibile generare la fattura",
    text31: "Sei sicuro di voler eliminare il metodo di pagamento?",
    text32: "Perderai i dati salvati",
    text33: "Elimina metodo",
    text34: "Annulla",

    // Corrections
    p1: "Abbonamento",
    p2: "Il tuo abbonamento",
    p3: "GRATUITO",
    p4: "PERSONALIZZATO",
    p5: "Non hai un abbonamento attivo. Rimediamo subito!",
    p6: "Scade:",
    p7: "Scegli un piano",
    p8: "Effettua l'upgrade",
    p9: "Numero di strutture",
    p10: "Per struttura",
    p11: "Gestisci abbonamento",
    p12: "Impostazioni di pagamento",
    p13: "Scade:",
    p14: "Modifica",
    p15: "Rinnovo automatico",
    p16: "Attivato",
    p17: "Il prossimo pagamento è previsto per",
    p18: "Fatture e ricevute",
    p19: "PERSONALIZZATO",
    p20: "Visualizza fattura",
    p21: "Scarica fattura",
    p22: "per",

    p23: "Mensile",
    p24: "Annuale",
    p25: "Ti regaliamo 2 mesi.",
    p26: "Tipo di abbonamento",


    p27: "Appartamento turistico",
    p28: "Hotel - Ostello",
    p29: "Campeggio",
    p30: "Villa",


    p31: `La "<strong>Struttura</strong>" si basa su singole case o appartamenti. Per gli "<strong>Aparthotel</strong>", ogni appartamento conta come una singola struttura`,
    p32: `Conta come
    <strong>Camere</strong> nel caso degli hotel, come letti nel caso degli ostelli,
    e come <strong>persone </strong> nel caso dei campeggi.

    <br />
    <strong>Per esempio:</strong> un ostello con 4 camere e 20 letti conterà come
    20 unità abitative`,

    p33: `PREMIUM`,
    p34: `mese`,
    p35: `camera`,
    p36: `appartamento`,
    p37: `Dettagli del piano`,
    p38: `Check-in in loco tramite QR`,
    p39: `Check-in con link inviato in anticipo`,
    p40: `Messaggio email di benvenuto`,
    p41: `Firma biometrica del regolamento`,
    p42: `Scanner documento d'identità - passaporto`,
    p43: `Spazio cloud illimitato`,
    p44: `Negozio di cross-selling`,
    p45: `Invio automatico delle comunicazioni alle autorità`,
    p46: `Sincronizzazione delle prenotazioni PSM`,
    p47: `Aggiorna abbonamento`,
    p48: `Continua`,
    p49: `per`,

    p50: `Seleziona servizi aggiuntivi per il tuo piano`,
    p51: `Consigliato`,
    p52: `WhatsApp`,
    p53: `Invitiamo i tuoi ospiti a effettuare il check-in tramite WhatsApp, programmato prima del loro arrivo nella tua struttura.`,
    p54: `appartamento`,
    p55: `villa`,
    p56: `posto`,
    p57: `camera`,
    p58: `Differenza nell'uso di WhatsApp`,
    p59: `Utilizzando il nostro WhatsApp`,
    p60: `Utilizzando il nostro servizio WhatsApp, il nome del mittente dei messaggi inviati ai tuoi ospiti sarà WACheckin. Gestiamo noi i messaggi per garantire una comunicazione efficace con i tuoi ospiti.`,
    p61: `Se utilizzi il nostro servizio con il tuo numero WhatsApp, il nome del mittente sarà il tuo nome WhatsApp e potrai avere il tuo badge di verifica. Il costo di invio sarà soggetto al consumo del tuo WhatsApp Business con Meta.`,
    p62: `Utilizzando il tuo WhatsApp Business`,
    p63: `Valutazioni`,
    p64: `Cogli questa opportunità per migliorare l'esperienza dei tuoi ospiti e ottenere più recensioni positive!`,
    p65: `Vantaggi`,
    p66: `Al checkout, invieremo ai tuoi ospiti un sondaggio di valutazione tramite WhatsApp, aumentando notevolmente la reputazione online della tua struttura. Il nostro servizio è pensato per incrementare le tue recensioni positive.`,
    p67: `Accesso da remoto`,
    p68: `Inviamo ai tuoi ospiti una chiave virtuale per l'accesso autonomo alla struttura.`,
    p69: `Vantaggi`,
    p70: `I tuoi ospiti riceveranno in modo sicuro e comodo le chiavi di accesso alla camera una volta completato il check-in, offrendo loro un'esperienza senza intoppi e migliorando l'efficienza nella gestione degli accessi.`,
    p71: `Verifica dell'identità`,
    p72: `Verifichiamo l'identità dei tuoi ospiti utilizzando il nostro software di comparazione biometrica.`,
    p73: `Vantaggi`,
    p74: `Verifichiamo l'identità dei tuoi ospiti utilizzando il nostro software di comparazione biometrica, assicurando che i loro documenti corrispondano alla persona che accede alla tua struttura.`,
    p75: `Abbonati ora`,
    p76: `Spazio cloud illimitato`,
    p77: `Personalizzato`,
    p78: `Chiedi al nostro team commerciale`,
    p79: `WhatsApp`,
    p80: `Verifica dell'identità`,
    p81: `Recensioni (valutazioni del check-in)`,
    p82: `Connessione tramite API per serrature intelligenti`,
    p83: `Addebito su carta (per depositi, servizi, ecc.)`,
    p84: `Contatta il team commerciale`,
    p85: ``,
    p86: ``,
    p87: ``,
    p88: ``,
    p89: ``,





};